import { FC, useCallback } from 'react';

import { fetchInfoFromVacancy } from 'components/AdQuickCreate/Vacancy/fetchInfoFromVacancy';
import { MagritteVacanciesSelect } from 'components/common/MagritteVacanciesSelect';

import {
    QuickCampaignFieldName,
    selectQuickCampaignFormDataField,
    selectQuickCampaignFormErrors,
    selectQuickCampaignVacancyName,
    setQuickCampaignFieldByName,
    setQuickCampaignVacancyName,
} from 'store/models/createQuickCampaign';
import { useDispatch, useSelector } from 'store/utils';

const Vacancy: FC = () => {
    const vacancyId = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.VacancyId]);
    const vacancyName = useSelector(selectQuickCampaignVacancyName);
    const error = useSelector(selectQuickCampaignFormErrors[QuickCampaignFieldName.VacancyId]);

    const dispatch = useDispatch();

    const chooseVacancy = useCallback(
        (value: string, name: string) => {
            dispatch([
                setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.VacancyId, value }),
                setQuickCampaignVacancyName(name),
            ]);
            void dispatch(fetchInfoFromVacancy(value));
        },
        [dispatch]
    );

    const resetVacancy = useCallback(() => {
        dispatch([
            setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.VacancyId, value: null }),
            setQuickCampaignVacancyName(''),
        ]);
    }, [dispatch]);

    return (
        <MagritteVacanciesSelect
            currentVacancyId={vacancyId}
            currentVacancyName={vacancyName}
            chooseVacancy={chooseVacancy}
            resetVacancy={resetVacancy}
            error={error}
        />
    );
};

export default Vacancy;
